export const getFormParams = (formData) => {
    if (formData) {
        const emptyKeys = [];

        for (const [key, value] of formData.entries()) {
            if (value.length === 0) {
                emptyKeys.push(key);
            }
        }

        for (let index = 0; index < emptyKeys.length; index++) {
            const key = emptyKeys[index];
            formData.delete(key);
        }

        return new URLSearchParams(formData);
    }
};
